import { render } from "./QueuedMessageIndicator.vue?vue&type=template&id=1c4ede1a&scoped=true"
import script from "./QueuedMessageIndicator.vue?vue&type=script&lang=js"
export * from "./QueuedMessageIndicator.vue?vue&type=script&lang=js"

import "./QueuedMessageIndicator.vue?vue&type=style&index=0&id=1c4ede1a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4ede1a"]])

export default __exports__